import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

/** Public Ads account picker, reached from the backend OAuth callback redirect. */
const ConnectorSelectPage = lazy(
  () => import('~/features/connector-share/pages/connector-select-page'),
);

export const Route = createFileRoute('/connector/$token/select')({
  component: () => (
    <Suspense fallback={null}>
      <ConnectorSelectPage />
    </Suspense>
  ),
});
